export function toUSD(value?: number, digits = 2) {
    return value?.toLocaleString("en-us", {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
        style: "currency",
        currency: "USD",
    });
}
